import { Outlet } from 'react-router-dom';
import { PartiesProvider } from '../contexts/PartiesProvider';
import { useUserState } from '../contexts/UserProvider';
import Login from '../pages/Login';

const AuthCheck: React.FC<{}> = () => {
  const { loggedInUser } = useUserState();

  if (!loggedInUser) {
    return <Login />;
  }

  return (
    <PartiesProvider>
      <Outlet />
    </PartiesProvider>
  );
};

export default AuthCheck;
